module.exports = __webpack_public_path__ + "static/media/example.91f1ec5b.png";